import PropTypes from 'prop-types';
import React from 'react';
import { VaBreadcrumbs } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import manifest from '../manifest.json';

const homeBreadcrumbs = [{ href: '/', label: 'Home' }];

const contactUsBreadcrumbs = [
  ...homeBreadcrumbs,
  { href: '/contact-us', label: 'Contact us' },
];

const askVABreadcrumbs = [
  ...contactUsBreadcrumbs,
  { href: manifest.rootUrl, label: 'Ask VA' },
];

const inboxBreadcrumbs = [
  ...askVABreadcrumbs,
  { href: `${manifest.rootUrl}/inbox`, label: 'Inbox' },
];

const getQuestionDetailsBreadcrumbs = currentPath => [
  ...inboxBreadcrumbs,
  {
    href: currentPath,
    label: 'Question details',
  },
];

const responseSentBreadcrumbs = [
  ...askVABreadcrumbs,
  { href: `${manifest.rootUrl}/response-sent`, label: 'Question sent' },
];

export const getBreadcrumbs = currentPath => {
  const path = currentPath.startsWith(manifest.rootUrl)
    ? currentPath.slice(manifest.rootUrl.length)
    : currentPath;

  if (path.startsWith('/inbox/'))
    return getQuestionDetailsBreadcrumbs(currentPath);
  if (path.startsWith('/inbox')) return inboxBreadcrumbs;
  if (path.startsWith('/response-sent')) return responseSentBreadcrumbs;
  return askVABreadcrumbs;
};

export default function BreadCrumbs({ currentPath }) {
  return (
    <div className="row">
      <div className="usa-width-two-thirds medium-8 columns">
        <VaBreadcrumbs
          label="Breadcrumbs"
          breadcrumbList={getBreadcrumbs(currentPath)}
          data-testid="Breadcrumb"
          currentPageRedirect
        />
      </div>
    </div>
  );
}

BreadCrumbs.propTypes = {
  currentPath: PropTypes.string.isRequired,
};
